/**
 * - Description -
 * TextService contains all the methods that allows the elaboration of the text:
 *   - bold;
 *   - italic;
 *   - links.
 * It is used to enrich the text.
 *
 * - Usage -
 * Using TextService
 *
 * import TextService from '@/helpers/TextService.js';
 * text = TextService.replaceBold(text);
 */
let randomString = require("randomstring");

export default {
    name: 'TextService',
    clearText: clearText,
    generateRandomString: generateRandomString,
    goUpperCaseFirst: goUpperCaseFirst,
    replaceBold: replaceBold,
    replaceItalic: replaceItalic,
    replaceLinks: replaceLinks,
    replaceImages: replaceImages,
    replaceJson: replaceJson,
    replaceButtons: replaceButtons,
    getButtonsFromText: getButtonsFromText,
    getSpecialButtonsFromText: getSpecialButtonsFromText,
    findPlaceholders: findPlaceholders,
    findVariables: findVariables,
    createPanelButton: createPanelButton,
    replaceSpecialButtons: replaceSpecialButtons,
    replaceCards: replaceCards,
    getCardsFromText: getCardsFromText,
    getPiechartsFromText: getPiechartFromText,
    replacePiecharts: replacePiecharts,
}
function getCardsFromText(text) {
    const regex = /\#card#(.*?)\#card#/g;
    const subst = "$1";
    let cardObjects = [];
    let cards = text.match(regex) || [];
    for (let i = 0; i < cards.length; i++) {
        let parts = cards[i].replace(regex, subst).split("#");
        let obj = {
            title: parts[0],
            description: parts[1],
            image: parts[2],
            text: parts[3]
        };
        cardObjects.push(obj)
    }
    return cardObjects;
}
function getPiechartFromText(text) {
    const regex = /\#piechart#(.*?)\#piechart#/g;
    const subst = "$1";
    let pieObjects = [];
    let piecharts = text.match(regex) || [];
    for (let i = 0; i < piecharts.length; i++) {
        let parts = piecharts[i].replace(regex, subst).split("#");
        let labels = parts[0].split(",");
        let values = parts[1].split(",");

        let obj = {
            labels: labels,
            values: values,
        };
        pieObjects.push(obj)
    }
    return pieObjects;
}

function replacePiecharts(text) {
    const regex = /\#piechart#(.*?)\#piechart#/g;
    const subst = "";
    return text.replace(regex, subst);
}

function generateRandomString(charNum) {
    //return Math.random().toString(36).substring(2, charNum);
    return randomString.generate(charNum);
}
function replaceCards(text) {
    const regex = /\#card#(.*?)\#card#/g;
    const subst = "";
    return text.replace(regex, subst);
}

/**
 * Clear all special characters from text
 */
function clearText(text) {
    const subst = "$1";
    let regex = /\_(.*?)\_/g;
    text = text.replace(regex, subst);
    regex = /\*(.*?)*/g;
    text = text.replace(regex, subst);
    return text;
}

/**
 * Used to make the first letter of the text uppercase
 */
function goUpperCaseFirst(text) {
    return text.charAt(0).toUpperCase() + text.slice(1);
}

function replaceBold(text) {
    const regex = /\*\*(.*?)\*\*/g;
    const subst = "<strong>$1</strong>";
    return text.replace(regex, subst);
}

function replaceItalic(text) {
    const regex = /\_\_(.*?)\_\_/g;
    const subst = "<i>$1</i>";
    return text.replace(regex, subst);
}

function replaceLinks(text) {
    const regex = /\#link#(.*?)\#link#/g;
    let matches = text.match(regex);
    if (matches !== null) {
        for (let i = 0; i < matches.length; i++) {
            let m = matches[i];
            m = m.replace(/#link#/g, "");
            let chunks = m.split(" ");
            let url = chunks[0];
            let tag = "LINK";
            if (chunks.length > 1) {
                tag = m.replace(url, "");
            }
            const subst = "<a href=\"" + url + "\" target=\"_blank\">" + tag + "</a>";
            text = text.replace(matches[i], subst);
        }
    }
    return text;
}

function replaceImages(text) {
    const regex = /\#image#(.*?)\#image#/g;
    const subst = "<img src=\"$1\" height=\"200px\"/>";
    return text.replace(regex, subst);
}


function createPanelButton(text, callback) {
    //callback("internal");
    const regex = /\#panel#(.*?)\#panel#/g;
    const subst = "<button @click='" + function () {
        callback("prova")
    } + "'>$1</button>";
    return text.replace(regex, subst);
}

function replaceJson(text) {
    const regex = /\#json_values#(.*?)\#json_values#/g;
    const subst = "$1";
    let onlyJsonText = text.replace(regex, subst);
    let jsonValues = onlyJsonText.split(",");
    let jsonStr = "";
    for (let i = 0; i < jsonValues.length; i++) {
        let keyAndValue = jsonValues[i].split(":");
        jsonStr = jsonStr + keyAndValue[0] + ": " + keyAndValue[1] + "<br>";
    }
    return text.replace(regex, jsonStr);
}


function replaceButtons(text) {
    const regex = /\#button#(.*?)\#button#/g;
    const subst = "";
    return text.replace(regex, subst);
}

function replaceSpecialButtons(text) {
    const regex = /\#specialButton#(.*?)\#specialButton#/g;
    const subst = "";
    return text.replace(regex, subst);
}


function getButtonsFromText(text) {
    const regex = /\#button#(.*?)\#button#/g;
    const subst = "$1";
    let buttons = text.match(regex) || [];
    for (let i = 0; i < buttons.length; i++) {
        buttons[i] = buttons[i].replace(regex, subst);
    }
    return buttons;
}

function getSpecialButtonsFromText(text) {
    const regex = /\#specialButton#(.*?)\#specialButton#/g;
    const subst = "$1";
    let buttons = text.match(regex) || [];
    for (let i = 0; i < buttons.length; i++) {
        buttons[i] = buttons[i].replace(regex, subst);
    }
    return buttons;
}


/**
 * findPlaceholders finds for placeholders in the IVE dialogic response
 */
function findPlaceholders(text) {
    if (text !== undefined) {
        let regex = /\[(.*?)\]/gm;
        return text.match(regex);
    }
    return null;
}

/**
 * findVariables finds for variables in the IVE dialogic user queries
 */
function findVariables(text) {
    if (text !== undefined) {
        let regex = /\<mark\>(.*?)\<\/mark\>/g;
        text = text.match(regex);
        if(text !== null) {
            for(let i=0; i<text.length; i++) {
                text[i] = text[i].replace("<mark>","");
                text[i] = text[i].replace("</mark>","");
            }

        }

        return text;
    }
    return null;
}
